import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'

import Device from '@/pages/Device'
import DeviceList from '@/pages/DeviceList'
import Home from '@/pages/Home'
import Incident from '@/pages/Incident'
import IncidentList from '@/pages/IncidentList'
import Login from '@/pages/Login'
import Measurement from '@/pages/Measurement'
import MeasurementList from '@/pages/MeasurementList'
import PageError from '@/pages/Error'
import Process from '@/pages/Process'
import ProcessList from '@/pages/ProcessList'
import ReportList from '@/pages/ReportList'

Vue.use(Router)

const router = new Router({
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/home/',
      name: 'home',
      component: Home,
      meta: { title: route => { return 'Inicio' } }
    },
    {
      path: '/dispositivos/',
      name: 'device-list',
      component: DeviceList,
      props: true,
      meta: { title: route => { return 'Dispositivos' } }
    },
    {
      path: '/dispositivos/:id',
      name: 'device-detail',
      component: Device,
      props: true,
      meta: { title: route => { return 'Dispositivos' } }
    },
    {
      path: '/pesadas/',
      name: 'measurement-list',
      component: MeasurementList,
      props: true,
      meta: { title: route => { return 'Pesadas' } }
    },
    {
      path: '/pesadas/:id',
      name: 'measurement-detail',
      component: Measurement,
      props: true,
      meta: { title: route => { return 'Pesada' + route.params.id } }
    },
    {
      path: '/incidencias/',
      name: 'incident-list',
      component: IncidentList,
      props: true,
      meta: { title: route => { return 'Incidencias' } }
    },
    {
      path: '/incidencias/:id',
      name: 'incident-detail',
      component: Incident,
      props: true,
      meta: { title: route => { return 'Incidencias' } }
    },
    {
      path: '/procesos/',
      name: 'process-list',
      component: ProcessList,
      props: true,
      meta: { title: route => { return 'Procesos' } }
    },
    {
      path: '/procesos/:id',
      name: 'process-detail',
      component: Process,
      props: true,
      meta: { title: route => { return 'Procesos' } }
    },
    {
      path: '/informes/',
      name: 'report-list',
      component: ReportList,
      props: true,
      meta: { title: route => { return 'Informes' } }
    },
    {
      path: '/error',
      name: 'error',
      component: PageError,
      props: true,
      meta: { title: route => { return 'Error de conexión' } }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: route => { return 'Login' } }
    },
    { path: '*', redirect: { name: 'home' } }
  ]
})

router.beforeEach((to, from, next) => {
  const session = JSON.parse(localStorage.getItem(Vue.config.app.sessionName))
  if (to['name'] !== 'login' && (!session || !session.token)) {
    return next({ name: 'login' })
  }

  if (to.meta.title) {
    document.title = store.state.pageTitle = to.meta.title(to)
  }
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js